import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import Toast, { POSITION } from 'vue-toastification'

import '@/assets/css/tailwind.css'
import '@/assets/css/fonts.css'
import 'animate.css'
import 'vue-toastification/dist/index.css'

const app = createApp(App)
app
  .use(store)
  .use(router)
  .use(Toast, { position: POSITION.BOTTOM_RIGHT })
  .mount('#app')
